import Paper from '@mui/material/Paper';
import { useState } from 'react';
import useAlert from '../../component/Alert/useAlert';
import { ContextSelect } from '../../component/ContextSelect';
import { CustomersTable } from '../../component/CustomerTable';
import { DiscountFilters } from '../../component/Discount/DiscountFilters';
import { DiscountTable } from '../../component/Discount/DiscountTable';
import { QrCode } from '../../component/QrCode';
import { customerRole } from '../../enum/customerRole';
import Title from '../../component/Title';
import { Box, Button } from '@mui/material';
import DiscountConditionApiService from '../../services/discountCondition.api.service';


const Discount = () => {
    const {showSuccessAlert, showErrorAlert} = useAlert();
    const [state, setState] = useState({
        context: null,
        customer: null,
        discount: null,
        loading: false,
        createMode: false,
        showFilters: false,
    });
    const [condition, setCondition] = useState({
        name: null,
        category: null,
        expires: null,
        amount: null,
        country: null,
        patient_type: null,
    });
    const [filters, setFilters] = useState({
        status: null,
        patientType: null,
        country: null,
        createdFrom: null,
        createdTo: null,
        category: null,
    });
    const defaultConditionState = {
        name: null,
        category: null,
        expires: null,
        amount: null,
        country: null,
        patient_type: null,
    };

    const changeState = (partialState) => setState(currentState => ({...currentState, ...partialState}));
    const changeFilters = (partialState) => setFilters(currentState => ({...currentState, ...partialState}));
    const changeConditionState = (partialState) => setCondition(currentState => ({...currentState, ...partialState}));
    const handleSubmit = () => {
        changeState({createMode: false});
        changeState({loading: true});
        DiscountConditionApiService
            .create({customer: state.customer.id, ...condition})
            .then(() => {
                showSuccessAlert('Discount condition successfully created');
                changeConditionState({...defaultConditionState});
                changeState({customer: {...state.customer}});
            })
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => changeState({loading: false}))
    };

    return (
        <Paper sx={{p: 4, display: 'flex', flexDirection: 'column', alignItems: 'left'}}>
            <Box
                component="form"
                noValidate={false}
                sx={{width: '100%'}}
            >
                <Title>1. Select the Business Context</Title>
                <ContextSelect onContextChange={context => changeState({context, customer: null})}/>
                <Title>2. Select customer with "Discount" role</Title>
                <CustomersTable
                    context={state.context}
                    role={customerRole.discounter}
                    onCustomerSelect={customer => changeState({customer})}
                />
                <Title>
                    3. Select discount
                    <Button
                        sx={{marginBottom: 1, marginLeft: 2}}
                        variant="outlined"
                        onClick={() => changeState({showFilters: !state.showFilters})}
                    >
                        {state.showFilters ? 'Hide filters' : 'Show filters'}
                    </Button>
                </Title>
                {state.showFilters && <DiscountFilters filters={filters} changeFilters={changeFilters} disabled={state.loading} />}
                <DiscountTable
                    filters={filters}
                    selectedDiscount={state.discount}
                    customer={state.customer}
                    onDiscountChange={discount => changeState({discount})}
                />
                {state.discount && <QrCode type="discount" hash={state.discount.hash}/>}
            </Box>
        </Paper>
    );
};

export default Discount;
